import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import 'vuetify/dist/vuetify.min.css'
import './stylus/main.styl'
import LiquorTree from 'liquor-tree'
import moment from 'moment'
import VueMoment from 'vue-moment'

Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(Vuetify, {
  theme: {
    primary: '#f3a947'
  }
})
Vue.use(VueChartkick, {adapter: Chart})
Vue.use(LiquorTree)
Vue.use(VueMoment, {
  moment
})

Vue.config.productionTip = false

moment.locale('ru')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    let accessToken = this.$cookie.get('accessToken')

    if (typeof (accessToken) !== 'undefined' && accessToken !== null) {
      this.$store.commit('setAccessToken', accessToken)
      this.$store.dispatch('autoLoginUser', {accessToken})
    } else {
      this.$router.push('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js